import GenreRow from "./GenreRow"
import {useEffect, useState} from 'react'
import { useNavigate } from "react-router-dom"
import {useSelector,useDispatch} from "react-redux"
import { fetchGenre } from "../store/actions"

export default function TableCategories(){
    const navigate= useNavigate()
    const dispatch= useDispatch()
    const {genres}= useSelector((state)=>state.genre)
    const [loading, setLoading]= useState(true)
    useEffect(()=>{
       dispatch(fetchGenre())
       .finally(()=>{
        setLoading(false)
       })
    },[])

    const toCreateGenre= (e)=>{
        e.preventDefault();
        navigate('/addGenre')
    }
    return (
        <div>
            
     <div className='pl-64 pt-10'>
        <h1 style={{fontSize: "40pt"}}>Genre List</h1>
        <div className="flex pt-5" style={{paddingLeft: "890px"}}>
    <button className='bg-green-400 rounded-lg' onClick={toCreateGenre} style={{width: "200px", height: "40px"}} >Create Genre</button>
        </div>
            <div className="flex pr-5 pt-5">
            <div className="overflow-x-auto relative shadow-md sm:rounded-lg" style={{width:"1100px"}}>
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="py-3 px-6">
                            No.
                        </th>
                        <th scope="col" className="py-3 px-6">
                            Name
                        </th>
                        <th scope="col" className="py-3 px-6">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? <div className="justify-center text-center items-center flex"> <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_qWnsM1rE89.json"  background="transparent"  speed="1"  style={{width: "500px" , height: "400px"}}  loop autoplay></lottie-player> </div> : genres.map((genre,i)=>
                    <GenreRow key={genre.id} i={i} genre={genre} />
                    )}
                </tbody>
            </table>
        </div>
            </div>
        </div>
        </div>
    )
}